import React, { useState, useEffect } from 'react';
import RelaysCTThreeUpdate from "./RelaysCTThreeUpdate";
import RelaysCTOneUpdate from "./RelaysCTOneUpdate";
import './RelaysCTTwo.css';

const phases = ['R', 'Y', 'B'];
const settingsHeaders = ['O/C 1', 'O/C 2', 'E/F 1', 'E/F 2', 'U/V 1', 'U/V 2', 'O/V 1', 'O/V 2'];
const settingsRows = ['ANSI Code', 'Set Value', 'Curve Type', 'TIME'];

const RelayMeasurements = ({ goBack, savedGeneralData, reportToUpdate, isUpdateMode }) => {
    
  
  const [formData, setFormData] = useState(() => {
    const savedData = savedGeneralData?.formData || {};
    return savedData;
  });

  const [showBackPage, setShowBackPage] = useState(false);
  const [showNextPage, setShowNextPage] = useState(false);
  const [rows, setRows] = useState(savedGeneralData?.rows || []);
  const [generalInspection, setGeneralInspection] = useState(savedGeneralData?.generalInspection || {});


  const convertDictToObject = (dictData, defaultStructure) => {
    if (!dictData || typeof dictData !== 'object') {
      return defaultStructure;
    }
    

    if (dictData.R || dictData.Y || dictData.B) {
      return dictData;
    }
    
 
    const converted = {};
    Object.keys(defaultStructure).forEach(phase => {
      converted[phase] = {};
      Object.keys(defaultStructure[phase]).forEach(type => {
        const phaseData = dictData[phase];
        if (phaseData && typeof phaseData === 'object') {
          const typeData = phaseData[type];
          if (typeData && typeof typeData === 'object') {
            
            const values = Object.values(typeData);
            converted[phase][type] = values.length > 0 ? values[0] : '';
          } else {
            converted[phase][type] = typeData || '';
          }
        } else {
          converted[phase][type] = '';
        }
      });
    });
    return converted;
  };

 
  const convertSettingsDict = (dictData) => {
    if (!dictData || typeof dictData !== 'object') {
      return settingsHeaders.reduce((acc, header) => {
        acc[header] = settingsRows.reduce((innerAcc, row) => {
          innerAcc[row] = '';
          return innerAcc;
        }, {});
        return acc;
      }, {});
    }
    
   
    if (dictData['O/C 1'] || dictData['O/C 2']) {
      return dictData;
    }
    
  
    const converted = {};
    settingsHeaders.forEach(header => {
      converted[header] = {};
      settingsRows.forEach(row => {
        const headerData = dictData[header];
        if (headerData && typeof headerData === 'object') {
          const rowData = headerData[row];
          if (rowData && typeof rowData === 'object') {
            const values = Object.values(rowData);
            converted[header][row] = values.length > 0 ? values[0] : '';
          } else {
            converted[header][row] = rowData || '';
          }
        } else {
          converted[header][row] = '';
        }
      });
    });
    return converted;
  };
  
  const [currentMeasurements, setCurrentMeasurements] = useState(() => {
  
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const currentDataFromReport = testData.currentData || testData.b_currentData || {};
        const defaultStructure = {
          R: { injected: '', measured: '' },
          Y: { injected: '', measured: '' },
          B: { injected: '', measured: '' },
        };
        const converted = convertDictToObject(currentDataFromReport, defaultStructure);
        
        return converted;
      } catch (error) {
        
      }
    }
    

    const savedMeasurements = localStorage.getItem('updateRelayCurrentMeasurements');
    return savedMeasurements ? JSON.parse(savedMeasurements) : {
      R: { injected: '', measured: '' },
      Y: { injected: '', measured: '' },
      B: { injected: '', measured: '' },
    };
  });

  
  const [voltageMeasurements, setVoltageMeasurements] = useState(() => {
  
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const voltageDataFromReport = testData.voltageData || testData.c_voltageData || {};
        const defaultStructure = {
          R: { injected: '', measured: '' },
          Y: { injected: '', measured: '' },
          B: { injected: '', measured: '' },
        };
        const converted = convertDictToObject(voltageDataFromReport, defaultStructure);
        
        return converted;
      } catch (error) {
        
      }
    }
    

    const savedMeasurements = localStorage.getItem('updateRelayVoltageMeasurements');
    return savedMeasurements ? JSON.parse(savedMeasurements) : {
      R: { injected: '', measured: '' },
      Y: { injected: '', measured: '' },
      B: { injected: '', measured: '' },
    };
  });

  
  const [settings, setSettings] = useState(() => {
  
    if (isUpdateMode && reportToUpdate?.test_data) {
      try {
        let testData = reportToUpdate.test_data;
        if (typeof testData === 'string') {
          testData = JSON.parse(testData);
        }
        const settingsDataFromReport = testData.settingsData || testData.d_settingsData || {};
        const converted = convertSettingsDict(settingsDataFromReport);
   
        return converted;
      } catch (error) {
       
      }
    }
    

    const savedSettings = localStorage.getItem('updateRelaySettings');
    return savedSettings ? JSON.parse(savedSettings) : 
      settingsHeaders.reduce((acc, header) => {
        acc[header] = settingsRows.reduce((innerAcc, row) => {
          innerAcc[row] = '';
          return innerAcc;
        }, {});
        return acc;
      }, {});
  });

  

  useEffect(() => {
    if (isUpdateMode && reportToUpdate?.test_data) {
      localStorage.setItem('updateRelayCurrentMeasurements', JSON.stringify(currentMeasurements));
      localStorage.setItem('updateRelayVoltageMeasurements', JSON.stringify(voltageMeasurements));
      localStorage.setItem('updateRelaySettings', JSON.stringify(settings));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('updateRelayCurrentMeasurements', JSON.stringify(currentMeasurements));
  }, [currentMeasurements]);

  
  useEffect(() => {
    localStorage.setItem('updateRelayVoltageMeasurements', JSON.stringify(voltageMeasurements));
  }, [voltageMeasurements]);

  
  useEffect(() => {
    localStorage.setItem('updateRelaySettings', JSON.stringify(settings));
  }, [settings]);

  
  useEffect(() => {
    const autoSaveInterval = setInterval(() => {
      localStorage.setItem('updateRelayCurrentMeasurements', JSON.stringify(currentMeasurements));
      localStorage.setItem('updateRelayVoltageMeasurements', JSON.stringify(voltageMeasurements));
      localStorage.setItem('updateRelaySettings', JSON.stringify(settings));
    }, 5000);

    return () => clearInterval(autoSaveInterval);
  }, [currentMeasurements, voltageMeasurements, settings]);

  
  const validateMeasurementInput = (value) => {
    
    return value === '' || /^-?\d*\.?\d*$/.test(value) ? value : '';
  };

  
  const validateSettingsInput = (value) => {

    return value === '' || /^[a-zA-Z0-9.\s]*$/.test(value) ? value : '';
  };

  const handleCurrentChange = (phase, type, value) => {
    
    const validatedValue = validateMeasurementInput(value);
    
    setCurrentMeasurements(prev => ({
      ...prev,
      [phase]: {
        ...prev[phase],
        [type]: validatedValue,
      }
    }));
  };

  const handleVoltageChange = (phase, type, value) => {
    
    const validatedValue = validateMeasurementInput(value);
    
    setVoltageMeasurements(prev => ({
      ...prev,
      [phase]: {
        ...prev[phase],
        [type]: validatedValue,
      }
    }));
  };

  const handleSettingsChange = (col, row, value) => {
    
    const validatedValue = validateSettingsInput(value);
    
    setSettings(prev => ({
      ...prev,
      [col]: {
        ...prev[col],
        [row]: validatedValue,
      }
    }));
  };

  const handleBack = () => {
    setShowBackPage(true);
  };

  const handleNext = (e) => {
    e.preventDefault();
    
    localStorage.setItem('updateRelayCurrentMeasurements', JSON.stringify(currentMeasurements));
    localStorage.setItem('updateRelayVoltageMeasurements', JSON.stringify(voltageMeasurements));
    localStorage.setItem('updateRelaySettings', JSON.stringify(settings));
    setShowNextPage(true);
  };


const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.")) {  
    localStorage.setItem('openReportsOnLoad', 'true');
    window.location.href = "/";
  }
};

  
  const clearFormData = () => {
    if (window.confirm("Are you sure you want to clear all measurements and settings?")) {
      
      const defaultCurrentMeasurements = {
        R: { injected: '', measured: '' },
        Y: { injected: '', measured: '' },
        B: { injected: '', measured: '' },
      };
      setCurrentMeasurements(defaultCurrentMeasurements);
      localStorage.setItem('updateRelayCurrentMeasurements', JSON.stringify(defaultCurrentMeasurements));
      
      
      const defaultVoltageMeasurements = {
        R: { injected: '', measured: '' },
        Y: { injected: '', measured: '' },
        B: { injected: '', measured: '' },
      };
      setVoltageMeasurements(defaultVoltageMeasurements);
      localStorage.setItem('updateRelayVoltageMeasurements', JSON.stringify(defaultVoltageMeasurements));
      
      
      const defaultSettings = settingsHeaders.reduce((acc, header) => {
        acc[header] = settingsRows.reduce((innerAcc, row) => {
          innerAcc[row] = '';
          return innerAcc;
        }, {});
        return acc;
      }, {});
      setSettings(defaultSettings);
      localStorage.setItem('updateRelaySettings', JSON.stringify(defaultSettings));
    }
  };

  if (showBackPage) {
    return <RelaysCTOneUpdate 
      goBack={() => setShowBackPage(false)} 
      savedGeneralFormData={formData} 
    />;
  }

  if (showNextPage) {
    return <RelaysCTThreeUpdate 
      goBack={() => setShowNextPage(false)} 
      savedGeneralData={{
        formData,
        rows,
        generalInspection,
        currentMeasurements,
        voltageMeasurements,
        settings
      }}
      reportToUpdate={reportToUpdate}
      isUpdateMode={isUpdateMode}
    />;
  }

  return (
    <div className="rt-1101">
      <span 
          style={{ 
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '20px', 
            fontWeight: '600', 
            color: '#333', 
            cursor: 'pointer',
            marginLeft: '50px',
            marginBottom: '50px'
          }}
          onClick={redirectToHome}
        >
          X
        </span>
      
      <div className="rt-1102">
        <h3 className="rt-h3">MEASUREMENTS : <span>Current</span></h3>
        <div className="rt-table rt-1103">
          <div className="rt-header">Phase </div>
          <div className="rt-header">Injected Current (Amp) </div>
          <div className="rt-header">Measured Current (Amp) </div>

          {phases.map(phase => (
            <React.Fragment key={phase}>
              <div className="rt-cell">{phase}</div>
              <input
                className="rt-input"
                type="text"
                placeholder="Enter Injected Current"
                value={currentMeasurements[phase].injected ||''}
                maxLength={10}
                onChange={e => handleCurrentChange(phase, 'injected', e.target.value)}
              />
              <input
                className="rt-input"
                type="text"
                placeholder="Enter Measured Current"
                value={currentMeasurements[phase].measured || ''}
                maxLength={10}
                onChange={e => handleCurrentChange(phase, 'measured', e.target.value)}
              />
            </React.Fragment>
          ))}
        </div>
      </div>

     
      <div className="rt-1104">
        <h3 className="rt-h3">MEASUREMENTS : <span>Voltage</span></h3>
        <div className="rt-table rt-1103">
          <div className="rt-header">Phase </div>
          <div className="rt-header">Injected Voltage (V) </div>
          <div className="rt-header">Measured Voltage (KV) </div>

          {phases.map(phase => (
            <React.Fragment key={phase}>
              <div className="rt-cell">{phase}</div>
              <input
                className="rt-input"
                type="text"
                placeholder="Enter Injected Voltage"
                value={voltageMeasurements[phase].injected || ''}
                maxLength={10}
                onChange={e => handleVoltageChange(phase, 'injected', e.target.value)}
              />
              <input
                className="rt-input"
                type="text"
                placeholder="Enter Measured Voltage"
                value={voltageMeasurements[phase].measured|| ''}
                maxLength={10}
                onChange={e => handleVoltageChange(phase, 'measured', e.target.value)}
              />
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="rt-1105">
        <h3 className="rt-h3">SETTINGS</h3>
        <div className="rt-settings-table">
          <div className="rt-column-label" style={{ backgroundColor: 'transparent', border: 'none' }}></div> 
          {settingsHeaders.map(header => (
            <div key={header} className="rt-column-label">{header}</div>
          ))}
          
          {settingsRows.map(row => (
            <React.Fragment key={row}>
              <div className="rt-row-label">{row}</div>
              {settingsHeaders.map(header => (
                <input 
                  key={`${row}-${header}`} 
                  className="rt-input"
                  value={settings[header][row] || ''}
                  maxLength={20}
                  onChange={e => handleSettingsChange(header, row, e.target.value)}
                  placeholder={`Enter ${row}`}
                />
              ))}
            </React.Fragment>
          ))}
        </div>

        <div className="rt-5514">
          <button type="button" onClick={handleBack} className="rt-5515">Back</button>
          
          <button type="button" onClick={handleNext} className="rt-5515">Next</button>
        </div>
      </div>
    </div>
  );
};

export default RelayMeasurements;